import { render, staticRenderFns } from "./cmp-upload-image.vue?vue&type=template&id=3b6ea7d1&scoped=true"
import script from "./cmp-upload-image.vue?vue&type=script&lang=js"
export * from "./cmp-upload-image.vue?vue&type=script&lang=js"
import style0 from "./cmp-upload-image.vue?vue&type=style&index=0&id=3b6ea7d1&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6ea7d1",
  null
  
)

export default component.exports